var moduleMap = {
	"./ErrorPage": () => {
		return Promise.all(/* __federation_expose_ErrorPage */[__webpack_require__.e(315), __webpack_require__.e(685), __webpack_require__.e(598), __webpack_require__.e(186), __webpack_require__.e(445), __webpack_require__.e(228), __webpack_require__.e(759)]).then(() => (() => ((__webpack_require__(7225)))));
	},
	"./SurveyApp": () => {
		return Promise.all(/* __federation_expose_SurveyApp */[__webpack_require__.e(315), __webpack_require__.e(405), __webpack_require__.e(598), __webpack_require__.e(186), __webpack_require__.e(445), __webpack_require__.e(228), __webpack_require__.e(126), __webpack_require__.e(551)]).then(() => (() => ((__webpack_require__(5007)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});